/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerlijn_Overdekopgaan5Inputs */

const nl_enums_leerlijn_overdekopgaan5 = /** @type {(inputs: Enums_Leerlijn_Overdekopgaan5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over de kop gaan`)
};

/**

* @param {Enums_Leerlijn_Overdekopgaan5Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerlijn_overdekopgaan5 = /** @type {((inputs?: Enums_Leerlijn_Overdekopgaan5Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerlijn_Overdekopgaan5Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerlijn_overdekopgaan5(inputs)
});
export { enums_leerlijn_overdekopgaan5 as "enums.Leerlijn.OverDeKopGaan" }